import type { BookStatus, BookType } from '@/types'

interface BookListFilters {
  type?: BookType
  /** A status, or 'all' to clear any saved status filter */
  status?: BookStatus | 'all'
  genre?: string
  rating?: number
  /** Only books finished in this year */
  year?: number
}

/**
 * Link to the book list matching the filters. Physical books live in "My Books",
 * digital ones in the "Digital Shelf"; the filters are applied once via the URL.
 */
export function bookListUrl({
  type = 'physical',
  status,
  genre,
  rating,
  year,
}: BookListFilters = {}) {
  const base = type === 'digital' ? '/dashboard/digital-shelf' : '/dashboard/books'
  const params = new URLSearchParams()
  if (status) params.set('status', status)
  if (genre) params.set('genre', genre)
  if (rating) params.set('rating', String(rating))
  if (year) params.set('year', String(year))
  const query = params.toString()
  return query ? `${base}?${query}` : base
}
